import React from 'react'
import axios from 'axios'

import './memberships-list.scss'

class MembershipsList extends React.Component {
  state = {
    links: [],
  }

  componentDidMount() {
    axios.get('https://www.instagram.com/bondcollective/')
      .then(res => {
        const { data } = res

        const matches = data.match(/"thumbnail_src":"([^"]*)"/g)
        const links = matches.map(m => {
          return m.match(/"thumbnail_src":"([^"]*)"/)[1]
        })

        this.setState({ links })
      })
  }

  render() {
    return (
      <div styleName='feed'>
        <h3>@bondcollective</h3>

        <div styleName="images">
          {this.state.links.map((link, i) => (
            <img src={link} key={i} />
          ))}
        </div>
      </div>
    )
  }
}

export default MembershipsList
